(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["also-love-products"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-form-mini')) {
    class ProductFormMini extends HTMLElement {
      connectedCallback() {
        this.btn = this.querySelector('[data-add-btn]');
        if (!this.btn) return;
        this.btn.addEventListener('click', () => this.addToCart());
      }

      addToCart() {
        const variantId = this.dataset.variantId;
        if (!variantId) return;
        const original = this.btn.textContent;
        this.btn.disabled = true;
        this.btn.textContent = 'Adding...';

        fetch(window.Shopify ? `${window.Shopify.routes.root}cart/add.js` : '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
        })
          .then((res) => {
            if (!res.ok) throw new Error('Add to cart failed');
            return res.json();
          })
          .then(() => {
            this.btn.textContent = 'Added!';
            this.btn.classList.add('is-added');
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            document.documentElement.dispatchEvent(new CustomEvent('cart:build'));
            setTimeout(() => {
              this.btn.disabled = false;
              this.btn.textContent = original;
              this.btn.classList.remove('is-added');
            }, 1800);
          })
          .catch(() => {
            this.btn.disabled = false;
            this.btn.textContent = original;
          });
      }
    }

    customElements.define('product-form-mini', ProductFormMini);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["before-after"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('before-after')) {
    class BeforeAfter extends HTMLElement {
      connectedCallback() {
        const range = this.querySelector('[data-range]');
        if (!range) return;
        const set = () => this.style.setProperty('--ba-pos', range.value + '%');
        range.addEventListener('input', set);
        set();
      }
    }
    customElements.define('before-after', BeforeAfter);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bins-merge"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bins-merge')) {
    class BinsMerge extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        if (!this.track) return;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

        this.ticking = false;
        this.onScroll = () => {
          if (this.ticking) return;
          this.ticking = true;
          requestAnimationFrame(() => {
            this.update();
            this.ticking = false;
          });
        };

        // Only listen while the section is on screen
        this.observer = new IntersectionObserver(([entry]) => {
          if (entry.isIntersecting) {
            window.addEventListener('scroll', this.onScroll, { passive: true });
            window.addEventListener('resize', this.onScroll, { passive: true });
            this.update();
          } else {
            window.removeEventListener('scroll', this.onScroll);
            window.removeEventListener('resize', this.onScroll);
          }
        });
        this.observer.observe(this);
        this.update();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
        if (this.observer) this.observer.disconnect();
      }

      update() {
        const rect = this.track.getBoundingClientRect();
        const total = rect.height - window.innerHeight;
        // Small hold at start and end so each state is readable
        let p = total > 0 ? -rect.top / total : 0;
        p = (p - 0.1) / 0.8;
        p = Math.min(Math.max(p, 0), 1);
        this.style.setProperty('--p', p.toFixed(3));
      }
    }

    customElements.define('bins-merge', BinsMerge);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-product-grid"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-grid-manual')) {
    class ProductGridManual extends HTMLElement {
      connectedCallback() {
        this.querySelectorAll('form[data-pg-form]').forEach((form) => {
          form.addEventListener('submit', (e) => this.onSubmit(e, form));
        });
      }

      // Adds the chosen variant without leaving the page and opens the cart drawer.
      // If the theme has no cart drawer, the normal form submit is used instead.
      async onSubmit(e, form) {
        const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        const canAjax =
          window.fetch &&
          cart &&
          typeof cart.renderContents === 'function' &&
          typeof cart.getSectionsToRender === 'function';
        if (!canAjax) return;

        e.preventDefault();
        const btn = form.querySelector('button[type="submit"]');
        if (btn.getAttribute('aria-busy') === 'true') return;
        btn.setAttribute('aria-busy', 'true');
        btn.disabled = true;

        const body = new FormData(form);
        body.append('sections', cart.getSectionsToRender().map((s) => s.id).join(','));
        body.append('sections_url', window.location.pathname);
        if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);

        try {
          const url = form.getAttribute('action').replace(/\.js$/, '') + '.js';
          const res = await fetch(url, {
            method: 'POST',
            headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
            body,
          });
          const json = await res.json();
          if (json.status) throw new Error(json.description || 'Could not add to cart');
          cart.renderContents(json);
        } catch (err) {
          btn.removeAttribute('aria-busy');
          btn.disabled = false;
          form.submit();
          return;
        }

        btn.removeAttribute('aria-busy');
        btn.disabled = false;
      }
    }

    customElements.define('product-grid-manual', ProductGridManual);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["compartment-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('compartment-tabs')) {
    class CompartmentTabs extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[data-tab]'));
        this.panels = Array.from(this.querySelectorAll('[data-panel]'));
        if (!this.tabs.length) return;

        this.tabs.forEach((tab, i) => {
          tab.addEventListener('click', () => this.select(i));
          tab.addEventListener('keydown', (e) => {
            if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
              e.preventDefault();
              const next = (i + (e.key === 'ArrowRight' ? 1 : -1) + this.tabs.length) % this.tabs.length;
              this.select(next);
              this.tabs[next].focus();
            }
          });
        });

        this.onBlockSelect = (e) => {
          const i = this.panels.findIndex((p) => p.dataset.blockId === e.detail.blockId);
          if (i >= 0) this.select(i);
        };
        document.addEventListener('shopify:block:select', this.onBlockSelect);
      }

      disconnectedCallback() {
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
      }

      select(i) {
        this.tabs.forEach((t, k) => {
          t.setAttribute('aria-selected', k === i ? 'true' : 'false');
          t.tabIndex = k === i ? 0 : -1;
        });
        this.panels.forEach((p, k) => p.classList.toggle('is-active', k === i));
      }
    }

    customElements.define('compartment-tabs', CompartmentTabs);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-announcement-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rotating-announcement')) {
    class RotatingAnnouncement extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.prev = this.querySelector('[data-prev]');
        this.next = this.querySelector('[data-next]');
        this.index = 0;
        this.paused = false;
        this.interval = parseInt(this.dataset.interval, 10) || 5000;

        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.autoplay = this.dataset.autoplay === 'true' && !reduce && this.slides.length > 1;

        if (this.prev) this.prev.addEventListener('click', () => { this.show(this.index - 1); this.restart(); });
        if (this.next) this.next.addEventListener('click', () => { this.show(this.index + 1); this.restart(); });

        // Pause while the visitor hovers or focuses inside the bar
        this.addEventListener('mouseenter', () => this.pause());
        this.addEventListener('mouseleave', () => this.resume());
        this.addEventListener('focusin', () => this.pause());
        this.addEventListener('focusout', () => this.resume());

        // Swipe on touch screens
        let startX = null;
        this.addEventListener('touchstart', (e) => { startX = e.touches[0].clientX; }, { passive: true });
        this.addEventListener(
          'touchend',
          (e) => {
            if (startX === null) return;
            const dx = e.changedTouches[0].clientX - startX;
            startX = null;
            if (Math.abs(dx) > 40) {
              this.show(this.index + (dx < 0 ? 1 : -1));
              this.restart();
            }
          },
          { passive: true }
        );

        this.onVisibility = () => (document.hidden ? this.stop() : this.start());
        document.addEventListener('visibilitychange', this.onVisibility);

        // Theme editor: selecting a message shows it
        this.onBlockSelect = (e) => {
          const i = this.slides.findIndex((s) => s.dataset.blockId === e.detail.blockId);
          if (i >= 0) {
            this.show(i);
            this.stop();
          }
        };
        document.addEventListener('shopify:block:select', this.onBlockSelect);

        this.start();
      }

      disconnectedCallback() {
        this.stop();
        document.removeEventListener('visibilitychange', this.onVisibility);
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
      }

      show(i) {
        const n = this.slides.length;
        this.index = (i + n) % n;
        this.slides.forEach((s, k) => {
          const active = k === this.index;
          s.classList.toggle('is-active', active);
          const link = s.querySelector('a');
          if (active) {
            s.removeAttribute('aria-hidden');
            if (link) link.removeAttribute('tabindex');
          } else {
            s.setAttribute('aria-hidden', 'true');
            if (link) link.setAttribute('tabindex', '-1');
          }
        });
      }

      start() {
        if (!this.autoplay || this.paused || this.timer) return;
        this.timer = setInterval(() => this.show(this.index + 1), this.interval);
      }

      stop() {
        clearInterval(this.timer);
        this.timer = null;
      }

      restart() {
        this.stop();
        this.start();
      }

      pause() {
        this.paused = true;
        this.stop();
      }

      resume() {
        this.paused = false;
        this.start();
      }
    }

    customElements.define('rotating-announcement', RotatingAnnouncement);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["expanding-banner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('expanding-banner')) {
    class ExpandingBanner extends HTMLElement {
      connectedCallback() {
        this.startAt = parseFloat(this.dataset.start) || 0.9;
        this.mobileQuery = window.matchMedia('(max-width: 749px)');
        this.reduceQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.ticking = false;

        this.onScroll = () => {
          if (this.ticking) return;
          this.ticking = true;
          requestAnimationFrame(() => {
            this.update();
            this.ticking = false;
          });
        };

        // Only listen to scroll while the banner is near the screen
        this.observer = new IntersectionObserver(
          ([entry]) => {
            if (entry.isIntersecting) {
              window.addEventListener('scroll', this.onScroll, { passive: true });
              window.addEventListener('resize', this.onScroll, { passive: true });
              this.update();
            } else {
              window.removeEventListener('scroll', this.onScroll);
              window.removeEventListener('resize', this.onScroll);
            }
          },
          { rootMargin: '10% 0px' }
        );
        this.observer.observe(this);

        this.update();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
        if (this.observer) this.observer.disconnect();
      }

      isStatic() {
        const noMobileEffect = this.mobileQuery.matches && this.dataset.mobileEffect !== 'true';
        return this.reduceQuery.matches || noMobileEffect;
      }

      update() {
        let p = 1;

        if (!this.isStatic()) {
          const rect = this.getBoundingClientRect();
          const vh = window.innerHeight;
          const start = vh * this.startAt;
          const end = vh * 0.1;
          const raw = Math.min(Math.max((start - rect.top) / (start - end), 0), 1);
          p = raw * raw * (3 - 2 * raw); // smooth ease
        }

        this.style.setProperty('--p', p.toFixed(3));
        this.dataset.on = p >= 0.6 ? 'true' : 'false';
      }
    }

    customElements.define('expanding-banner', ExpandingBanner);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-image"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('faq-accordion')) {
    class FaqAccordion extends HTMLElement {
      connectedCallback() {
        this.single = this.dataset.single === 'true';
        this.querySelectorAll('[data-faq-toggle]').forEach((btn) => {
          btn.addEventListener('click', () => this.toggle(btn));
        });

        this.setupVideo();
      }

      setupVideo() {
        const mediaContainer = this.querySelector('[data-faq-media]');
        if (!mediaContainer) return;
        
        const video = mediaContainer.querySelector('video');
        const playBtn = mediaContainer.querySelector('[data-faq-play]');
        if (!video || !playBtn) return;

        // Apply speed setting
        const speed = parseFloat(video.getAttribute('data-speed')) || 1.25;
        video.playbackRate = speed;

        playBtn.addEventListener('click', () => {
          if (video.paused) {
            video.playbackRate = speed;
            video.play();
            mediaContainer.classList.add('is-playing');
            video.controls = true;
          } else {
            video.pause();
            mediaContainer.classList.remove('is-playing');
            video.controls = false;
          }
        });

        video.addEventListener('pause', () => {
          mediaContainer.classList.remove('is-playing');
          video.controls = false;
        });
      }

      setItem(item, open) {
        const btn = item.querySelector('[data-faq-toggle]');
        const panel = item.querySelector('.faq__answer');
        item.classList.toggle('is-open', open);
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) {
          panel.removeAttribute('inert');
        } else {
          panel.setAttribute('inert', '');
        }
      }

      toggle(btn) {
        const item = btn.closest('.faq__item');
        const willOpen = !item.classList.contains('is-open');

        if (this.single && willOpen) {
          this.querySelectorAll('.faq__item.is-open').forEach((other) => {
            if (other !== item) this.setItem(other, false);
          });
        }
        this.setItem(item, willOpen);
      }
    }

    customElements.define('faq-accordion', FaqAccordion);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["feature-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('feature-slider')) {
    class FeatureSlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.dotsWrap = this.querySelector('[data-dots]');

        this.setupDrawer();
        if (!this.track) return;

        this.cards = Array.from(this.track.children);

        this.onScroll = () => {
          cancelAnimationFrame(this.raf);
          this.raf = requestAnimationFrame(() => this.setActive());
        };
        this.track.addEventListener('scroll', this.onScroll, { passive: true });

        this.onResize = () => {
          clearTimeout(this.resizeTimer);
          this.resizeTimer = setTimeout(() => this.buildDots(), 150);
        };
        window.addEventListener('resize', this.onResize);

        this.buildDots();
        this.setupDrag();
        this.setupVideos();
      }

      disconnectedCallback() {
        if (this.track) this.track.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onResize);
        document.removeEventListener('keydown', this.onKey);
        if (this.videoObserver) this.videoObserver.disconnect();
        document.documentElement.classList.remove('fs-lock');
        // The drawer lives in <body>, so remove it when the section is re-rendered in the editor
        if (this.drawer && this.drawer.parentNode) this.drawer.remove();
      }

      /* ---------- Drawer ---------- */
      setupDrawer() {
        this.drawer = this.querySelector('[data-drawer]');
        if (!this.drawer) return;

        // Move to <body> so it sits above everything (sticky header, overflow, etc.)
        const existing = document.getElementById(this.drawer.id);
        if (existing && existing !== this.drawer) existing.remove();
        document.body.appendChild(this.drawer);

        this.drawerTitle = this.drawer.querySelector('[data-drawer-title]');
        this.drawerBody = this.drawer.querySelector('[data-drawer-body]');
        this.drawerPanel = this.drawer.querySelector('.fs-drawer__panel');

        this.querySelectorAll('[data-open-drawer]').forEach((btn) => {
          btn.addEventListener('click', () => this.openDrawer(btn));
        });

        this.drawer.querySelectorAll('[data-close-drawer]').forEach((el) => {
          el.addEventListener('click', () => this.closeDrawer());
        });

        this.onKey = (e) => {
          if (!this.drawer.classList.contains('is-open')) return;
          if (e.key === 'Escape') {
            this.closeDrawer();
          } else if (e.key === 'Tab') {
            this.trapFocus(e);
          }
        };
        document.addEventListener('keydown', this.onKey);
      }

      openDrawer(btn) {
        const tpl = this.querySelector('#' + btn.dataset.template);
        if (!tpl) return;

        clearTimeout(this.hideTimer);
        this.drawerTitle.textContent = btn.dataset.title || '';
        this.drawerBody.replaceChildren(tpl.content.cloneNode(true));
        this.drawerBody.scrollTop = 0;

        this.lastTrigger = btn;
        btn.setAttribute('aria-expanded', 'true');

        this.drawer.hidden = false;
        document.documentElement.classList.add('fs-lock');
        requestAnimationFrame(() => {
          requestAnimationFrame(() => this.drawer.classList.add('is-open'));
        });

        const closeBtn = this.drawer.querySelector('.fs-drawer__close');
        setTimeout(() => closeBtn && closeBtn.focus({ preventScroll: true }), 50);
      }

      closeDrawer() {
        if (!this.drawer || this.drawer.hidden) return;
        this.drawer.classList.remove('is-open');
        document.documentElement.classList.remove('fs-lock');

        if (this.lastTrigger) {
          this.lastTrigger.setAttribute('aria-expanded', 'false');
          this.lastTrigger.focus({ preventScroll: true });
        }

        this.hideTimer = setTimeout(() => {
          this.drawer.hidden = true;
          this.drawerBody.replaceChildren();
        }, 450);
      }

      trapFocus(e) {
        const focusables = this.drawer.querySelectorAll(
          'a[href], button:not([disabled]):not([tabindex="-1"]), input, select, textarea, [tabindex]:not([tabindex="-1"])'
        );
        if (!focusables.length) return;
        const first = focusables[0];
        const last = focusables[focusables.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }

      /* ---------- Dots ---------- */
      getPositions() {
        const pad = parseFloat(getComputedStyle(this.track).paddingLeft) || 0;
        const max = this.track.scrollWidth - this.track.clientWidth;
        const positions = [];
        this.cards.forEach((card) => {
          const pos = Math.round(Math.min(Math.max(card.offsetLeft - pad, 0), max));
          if (!positions.some((p) => Math.abs(p - pos) < 4)) positions.push(pos);
        });
        return positions;
      }

      nearestIndex(x) {
        let active = 0;
        let best = Infinity;
        (this.positions || []).forEach((pos, i) => {
          const d = Math.abs(pos - x);
          if (d < best) {
            best = d;
            active = i;
          }
        });
        return active;
      }

      buildDots() {
        this.positions = this.getPositions();
        if (!this.dotsWrap) return;
        this.dotsWrap.innerHTML = '';
        if (this.positions.length < 2) return;

        this.positions.forEach((pos, i) => {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'fs__dot';
          dot.setAttribute('aria-label', `Go to slide ${i + 1}`);
          dot.addEventListener('click', () => this.track.scrollTo({ left: pos, behavior: 'smooth' }));
          this.dotsWrap.appendChild(dot);
        });
        this.setActive();
      }

      setActive() {
        if (!this.positions || !this.dotsWrap) return;
        const active = this.nearestIndex(this.track.scrollLeft);
        Array.from(this.dotsWrap.children).forEach((dot, i) => {
          dot.setAttribute('aria-current', i === active ? 'true' : 'false');
        });
      }

      /* ---------- Mouse drag ---------- */
      setupDrag() {
        const track = this.track;
        let isDown = false;
        let moved = false;
        let startX = 0;
        let startScroll = 0;
        let startIndex = 0;
        let pointerId = null;

        track.addEventListener('pointerdown', (e) => {
          moved = false;
          if (e.pointerType !== 'mouse' || e.button !== 0) return;
          if (e.target.closest('[data-open-drawer], a, button')) return;

          isDown = true;
          startX = e.clientX;
          startScroll = track.scrollLeft;
          startIndex = this.nearestIndex(startScroll);
          pointerId = e.pointerId;
        });

        track.addEventListener('pointermove', (e) => {
          if (!isDown || e.pointerId !== pointerId) return;
          const dx = e.clientX - startX;

          if (!moved && Math.abs(dx) > 5) {
            moved = true;
            track.classList.add('is-dragging');
            track.setPointerCapture(pointerId);
          }

          if (moved) {
            e.preventDefault();
            track.scrollLeft = startScroll - dx;
          }
        });

        const endDrag = (e) => {
          if (!isDown || (e && e.pointerId !== pointerId)) return;
          isDown = false;
          if (!moved) return;

          const dx = e ? e.clientX - startX : 0;
          const positions = this.positions || [];
          let target = this.nearestIndex(track.scrollLeft);

          if (target === startIndex && Math.abs(dx) > 60) {
            target = dx < 0 ? startIndex + 1 : startIndex - 1;
          }
          target = Math.max(0, Math.min(positions.length - 1, target));

          if (track.hasPointerCapture(pointerId)) track.releasePointerCapture(pointerId);

          track.scrollTo({ left: positions[target] ?? track.scrollLeft, behavior: 'smooth' });
          const restore = () => {
            track.classList.remove('is-dragging');
            track.removeEventListener('scrollend', restore);
            clearTimeout(this.snapTimer);
          };
          if ('onscrollend' in window) track.addEventListener('scrollend', restore);
          this.snapTimer = setTimeout(restore, 600);
        };

        track.addEventListener('pointerup', endDrag);
        track.addEventListener('pointercancel', endDrag);

        track.addEventListener(
          'click',
          (e) => {
            if (moved) {
              e.preventDefault();
              e.stopPropagation();
              moved = false;
            }
          },
          true
        );

        track.addEventListener('dragstart', (e) => e.preventDefault());
      }

      /* ---------- Videos: play only when visible ---------- */
      setupVideos() {
        const videos = this.querySelectorAll('video');
        if (!videos.length || !('IntersectionObserver' in window)) return;
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.videoObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              const video = entry.target;
              if (entry.isIntersecting && !reduce) {
                video.play().catch(() => {});
              } else {
                video.pause();
              }
            });
          },
          { threshold: 0.4 }
        );
        videos.forEach((v) => this.videoObserver.observe(v));
      }
    }

    customElements.define('feature-slider', FeatureSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  function initMegaMenu() {
    const triggers = document.querySelectorAll('.header__desktop-item--megamenu');

    triggers.forEach((trigger) => {
      let closeTimer = null;

      const open = () => {
        clearTimeout(closeTimer);
        trigger.classList.add('is-open');
      };

      const scheduleClose = () => {
        clearTimeout(closeTimer);
        closeTimer = setTimeout(() => {
          trigger.classList.remove('is-open');
        }, 250);
      };

      trigger.addEventListener('mouseenter', open);
      trigger.addEventListener('mouseleave', scheduleClose);
      trigger.addEventListener('focusin', open);
      trigger.addEventListener('focusout', (e) => {
        if (!trigger.contains(e.relatedTarget)) scheduleClose();
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMegaMenu);
  } else {
    initMegaMenu();
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hotspot-explorer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hotspot-carousel')) {
    class HotspotCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.cards = Array.from(this.querySelectorAll('[data-card]'));
        this.prevBtn = this.querySelector('[data-prev]');
        this.nextBtn = this.querySelector('[data-next]');
        this.dots = Array.from(this.querySelectorAll('[data-dot]'));
        if (!this.track || !this.cards.length) return;

        this.prevBtn.addEventListener('click', () => this.scrollByCards(-1));
        this.nextBtn.addEventListener('click', () => this.scrollByCards(1));
        this.dots.forEach((d) => d.addEventListener('click', () => this.scrollToCard(parseInt(d.dataset.dot, 10))));

        this.track.addEventListener('scroll', () => this.onScroll(), { passive: true });
        window.addEventListener('resize', () => this.updateArrows());

        this.querySelectorAll('[data-play]').forEach((btn) => {
          btn.addEventListener('click', () => {
            const stage = btn.closest('[data-stage]');
            const video = stage.querySelector('video');
            if (!video) return;
            if (video.paused) {
              video.setAttribute('controls', '');
              video.play();
              stage.classList.add('is-playing');
            } else {
              video.pause();
              stage.classList.remove('is-playing');
            }
          });
        });

        this.updateArrows();
      }

      cardStep() {
        return this.cards[1]
          ? this.cards[1].offsetLeft - this.cards[0].offsetLeft
          : this.cards[0].offsetWidth;
      }

      scrollByCards(dir) {
        this.track.scrollBy({ left: this.cardStep() * dir, behavior: 'smooth' });
      }

      scrollToCard(index) {
        const card = this.cards[index];
        if (!card) return;
        this.track.scrollTo({ left: card.offsetLeft - this.track.offsetLeft, behavior: 'smooth' });
      }

      onScroll() {
        const scrollLeft = this.track.scrollLeft;
        const step = this.cardStep();
        const active = Math.round(scrollLeft / step);
        this.dots.forEach((d, k) => d.setAttribute('aria-current', k === active ? 'true' : 'false'));
        this.updateArrows();
      }

      updateArrows() {
        const maxScroll = this.track.scrollWidth - this.track.clientWidth - 2;
        this.prevBtn.disabled = this.track.scrollLeft <= 2;
        this.nextBtn.disabled = this.track.scrollLeft >= maxScroll;
      }
    }

    customElements.define('hotspot-carousel', HotspotCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["how-steps"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('how-steps')) {
    class HowSteps extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.dotsWrap = this.querySelector('[data-dots]');
        if (!this.track) return;

        this.cards = Array.from(this.track.children);

        this.onScroll = () => {
          cancelAnimationFrame(this.raf);
          this.raf = requestAnimationFrame(() => this.setActive());
        };
        this.track.addEventListener('scroll', this.onScroll, { passive: true });

        this.onResize = () => {
          clearTimeout(this.resizeTimer);
          this.resizeTimer = setTimeout(() => this.buildDots(), 150);
        };
        window.addEventListener('resize', this.onResize);

        this.buildDots();
        this.setupVideos();
      }

      disconnectedCallback() {
        if (this.track) this.track.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onResize);
      }

      buildDots() {
        if (!this.dotsWrap) return;
        this.dotsWrap.innerHTML = '';
        const scrolls = this.track.scrollWidth > this.track.clientWidth + 4;
        if (!scrolls || this.cards.length < 2) return;

        this.cards.forEach((card, i) => {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'hs__dot';
          dot.setAttribute('aria-label', `Go to step ${i + 1}`);
          dot.addEventListener('click', () => {
            const pad = parseFloat(getComputedStyle(this.track).paddingLeft) || 0;
            this.track.scrollTo({ left: card.offsetLeft - pad, behavior: 'smooth' });
          });
          this.dotsWrap.appendChild(dot);
        });
        this.setActive();
      }

      setActive() {
        if (!this.dotsWrap || !this.dotsWrap.children.length) return;
        const pad = parseFloat(getComputedStyle(this.track).paddingLeft) || 0;
        const x = this.track.scrollLeft;
        let active = 0;
        let best = Infinity;
        this.cards.forEach((card, i) => {
          const d = Math.abs(card.offsetLeft - pad - x);
          if (d < best) {
            best = d;
            active = i;
          }
        });
        if (x + this.track.clientWidth >= this.track.scrollWidth - 4) active = this.cards.length - 1;
        Array.from(this.dotsWrap.children).forEach((dot, i) => {
          dot.setAttribute('aria-current', i === active ? 'true' : 'false');
        });
      }

      setupVideos() {
        const mediaContainers = this.querySelectorAll('.hs__media');
        mediaContainers.forEach((container) => {
          const video = container.querySelector('video');
          const playBtn = container.querySelector('.hs__play-btn');
          if (!video || !playBtn) return;

          playBtn.addEventListener('click', () => {
            if (video.paused) {
              video.play();
              container.classList.add('is-playing');
              video.controls = true;
            } else {
              video.pause();
              container.classList.remove('is-playing');
              video.controls = false;
            }
          });

          video.addEventListener('pause', () => {
            container.classList.remove('is-playing');
            video.controls = false;
          });
        });
      }
    }

    customElements.define('how-steps', HowSteps);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["metric-counter"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('metric-counter')) {
    class MetricCounter extends HTMLElement {
      connectedCallback() {
        this.counters = Array.from(this.querySelectorAll('[data-count]'));
        this.duration = parseFloat(this.dataset.duration) || 2000;

        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const editor = window.Shopify && window.Shopify.designMode;
        if (reduce || editor || !('IntersectionObserver' in window)) return; // keep final numbers

        // Reset to the start value, then count up once the section is visible
        this.counters.forEach((el) => {
          el.textContent = this.format(parseFloat(el.dataset.start) || 0, el);
        });

        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                this.run();
                this.observer.disconnect();
              }
            });
          },
          { threshold: 0.35 }
        );
        this.observer.observe(this);
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        cancelAnimationFrame(this.raf);
      }

      format(value, el) {
        const decimals = parseInt(el.dataset.decimals, 10) || 0;
        return value.toFixed(decimals);
      }

      run() {
        const items = this.counters.map((el) => ({
          el,
          from: parseFloat(el.dataset.start) || 0,
          to: parseFloat(String(el.dataset.target).replace(',', '.')) || 0,
        }));
        const startTime = performance.now();
        const ease = (t) => 1 - Math.pow(1 - t, 3); // ease-out cubic

        const tick = (now) => {
          const t = Math.min((now - startTime) / this.duration, 1);
          const k = ease(t);
          items.forEach(({ el, from, to }) => {
            el.textContent = t < 1 ? this.format(from + (to - from) * k, el) : el.dataset.target;
          });
          if (t < 1) this.raf = requestAnimationFrame(tick);
        };
        this.raf = requestAnimationFrame(tick);
      }
    }

    customElements.define('metric-counter', MetricCounter);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-custom-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('adumi-product')) {
    class AdumiProduct extends HTMLElement {
      connectedCallback() {
        this.slidesEl = this.querySelector('[data-slides]');
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.thumbs = Array.from(this.querySelectorAll('[data-thumb]'));
        this.thumbsList = this.querySelector('[data-thumbs]');
        this.counter = this.querySelector('[data-counter]');
        this.prev = this.querySelector('[data-prev]');
        this.next = this.querySelector('[data-next]');
        this.index = 0;

        this.picker = this.querySelector('[data-variant-picker]');
        this.setupGallery();
        this.setupTabs();
        this.setupVariants();
        this.setupQuantity();
        this.setupBundles();
        this.setupSocialVideos();
      }

      disconnectedCallback() {
        if (this.slideObserver) this.slideObserver.disconnect();
      }

      /* ---------- Gallery ---------- */
      setupGallery() {
        if (!this.slidesEl || this.slides.length < 2) return;

        this.thumbs.forEach((t) => t.addEventListener('click', () => this.goTo(parseInt(t.dataset.thumb, 10))));
        if (this.prev) this.prev.addEventListener('click', () => this.goTo(this.index - 1));
        if (this.next) this.next.addEventListener('click', () => this.goTo(this.index + 1));

        this.slidesEl.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowLeft') this.goTo(this.index - 1);
          if (e.key === 'ArrowRight') this.goTo(this.index + 1);
        });

        // Track which slide is in view (also after swiping on mobile)
        this.slideObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting && entry.intersectionRatio > 0.6) {
                this.setActive(parseInt(entry.target.dataset.slide, 10));
              }
            });
          },
          { root: this.slidesEl, threshold: [0.6] }
        );
        this.slides.forEach((s) => this.slideObserver.observe(s));

        // Start on the selected variant's image
        const start = this.slides.findIndex((s) => s.dataset.mediaId === this.dataset.startMedia);
        if (start > 0) this.goTo(start, false);
        else this.setActive(0);

        this.filterByColor(this.getCurrentColorValue());
      }

      getCurrentColorValue() {
        const idx = parseInt(this.dataset.colorOptionIndex, 10);
        if (isNaN(idx) || idx < 0 || !this.picker) return null;
        const fieldsets = Array.from(this.picker.querySelectorAll('fieldset'));
        const fs = fieldsets[idx];
        if (!fs) return null;
        const checked = fs.querySelector('input:checked');
        return checked ? checked.value.toLowerCase() : null;
      }

filterByColor(colorValue) {
  if (!colorValue) return;

  const thumbLis = this.thumbs.map((t) => t.closest('li'));
  this.thumbs.forEach((t, i) => {
    const tag = t.dataset.mediaColor;
    const visible = !tag || tag === colorValue;
    if (thumbLis[i]) thumbLis[i].style.display = visible ? '' : 'none';
  });

  this.slides.forEach((s) => {
    const tag = s.dataset.mediaColor;
    const visible = !tag || tag === colorValue;
    s.style.display = visible ? '' : 'none';
  });

  // Always snap to the FIRST visible slide for this color — not only when the
  // previously active slide got hidden. This guarantees we land on the first
  // matching image (e.g. the first black photo) every time filtering runs,
  // whether on initial page load or a manual variant/swatch change.
  const firstVisible = this.slides.findIndex((s) => s.style.display !== 'none');
  if (firstVisible >= 0) this.goTo(firstVisible, false);
}

      goTo(i, smooth = true) {
        if (!this.slides.length) return;
        const target = Math.max(0, Math.min(this.slides.length - 1, i));
        this.slidesEl.scrollTo({ left: this.slides[target].offsetLeft, behavior: smooth ? 'smooth' : 'auto' });
        this.setActive(target);
      }

      goToMedia(mediaId) {
        const i = this.slides.findIndex((s) => s.dataset.mediaId === String(mediaId));
        if (i >= 0) this.goTo(i);
      }

      setActive(i) {
        if (i === this.index && this.activeSet) return;
        this.index = i;
        this.activeSet = true;

        this.thumbs.forEach((t, n) => t.setAttribute('aria-current', n === i ? 'true' : 'false'));
        if (this.counter) this.counter.textContent = i + 1;
        if (this.prev) this.prev.disabled = i === 0;
        if (this.next) this.next.disabled = i === this.slides.length - 1;

        // Keep the active thumbnail in view inside its own list (no page jump)
        const thumb = this.thumbs[i];
        if (thumb && this.thumbsList) {
          const list = this.thumbsList;
          const vertical = list.scrollHeight > list.clientHeight + 2;
          if (vertical) {
            const top = thumb.offsetTop - list.clientHeight / 2 + thumb.offsetHeight / 2;
            list.scrollTo({ top, behavior: 'smooth' });
          } else {
            const left = thumb.offsetLeft - list.clientWidth / 2 + thumb.offsetWidth / 2;
            list.scrollTo({ left, behavior: 'smooth' });
          }
        }

        // Pause videos that are not on screen
        this.slides.forEach((s, n) => {
          if (n === i) return;
          const v = s.querySelector('video');
          if (v && !v.paused) v.pause();
        });
      }

      /* ---------- Tabs (Product / Before & After / Video) ---------- */
      setupTabs() {
        this.tabs = Array.from(this.querySelectorAll('[data-tab]'));
        if (!this.tabs.length) return;
        this.tabs.forEach((tab) => {
          tab.addEventListener('click', () => this.activateTab(tab.dataset.tab));
        });
      }

      activateTab(category) {
        this.tabs.forEach((t) => {
          const active = t.dataset.tab === category;
          t.classList.toggle('is-active', active);
          t.setAttribute('aria-selected', active ? 'true' : 'false');
        });

        this.thumbs.forEach((t) => {
          const match = t.dataset.category === category;
          const li = t.closest('li');
          if (li) li.style.display = match ? '' : 'none';
        });

        const firstMatch = this.slides.find((s) => s.dataset.category === category);
        if (firstMatch) this.goTo(this.slides.indexOf(firstMatch));
      }

      /* ---------- Variants ---------- */
      setupVariants() {
        this.picker = this.querySelector('[data-variant-picker]');
        this.idInput = this.querySelector('[data-variant-id]');
        this.addButton = this.querySelector('[data-add-button]');
        this.addLabel = this.querySelector('[data-add-label]');
        this.priceEl = this.querySelector('[data-price]');
        this.addText = this.addButton ? this.addButton.dataset.addText : '';

        try {
          this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
          this.moneyFormat = JSON.parse(this.querySelector('[data-money-format]').textContent);
        } catch (e) {
          this.variants = [];
        }

        if (!this.picker) return;
        this.picker.addEventListener('change', () => this.onOptionChange());
        this.updateAvailability();
      }

      selectedOptions() {
        const fieldsets = Array.from(this.picker.querySelectorAll('fieldset'));
        return fieldsets.map((fs) => {
          const checked = fs.querySelector('input:checked');
          return checked ? checked.value : null;
        });
      }

      onOptionChange() {
        const options = this.selectedOptions();
        options.forEach((val, i) => {
          const label = this.querySelector(`[data-option-label="${i}"]`);
          if (label) label.textContent = val;
        });

        const variant = this.variants.find((v) => v.options.every((o, i) => o === options[i]));
        this.updateAvailability();

        if (!variant) {
          this.setButton(false, this.dataset.unavailable);
          return;
        }

        if (this.idInput) this.idInput.value = variant.id;
        this.updatePrice(variant);
        this.setButton(variant.available, variant.available ? this.addText : this.dataset.soldOut);
        if (variant.featured_media) this.goToMedia(variant.featured_media.id);
        this.filterByColor(this.getCurrentColorValue());

        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }

      // Strike through values that can't be bought with the other current choices
      updateAvailability() {
        const options = this.selectedOptions();
        this.picker.querySelectorAll('input[data-option-index]').forEach((input) => {
          const idx = parseInt(input.dataset.optionIndex, 10);
          const test = options.slice();
          test[idx] = input.value;
          const match = this.variants.find((v) => v.options.every((o, i) => o === test[i]));
          input.closest('[data-value-wrap]').classList.toggle('is-unavailable', !match || !match.available);
        });
      }

      setButton(available, text) {
        if (!this.addButton) return;
        this.addButton.disabled = !available;
        if (this.addLabel && text) this.addLabel.textContent = text;
      }

      updatePrice(variant) {
        if (!this.priceEl) return;
        const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
        this.priceEl.classList.toggle('price--on-sale', !!onSale);
        const price = this.formatMoney(variant.price);
        this.priceEl.querySelector('[data-price-regular]').textContent = price;
        this.priceEl.querySelector('[data-price-sale]').textContent = price;
        this.priceEl.querySelector('[data-price-compare]').textContent = onSale ? this.formatMoney(variant.compare_at_price) : '';

        // Keep the "X% <badge text>" pill in sync with whichever variant is now selected.
        const badgeEl = this.querySelector('[data-price-badge]');
        if (badgeEl) {
          if (onSale) {
            const suffix = badgeEl.dataset.badgeText || '';
            const percent = Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);
            badgeEl.textContent = `${percent}% ${suffix}`;
          } else {
            badgeEl.textContent = '';
          }
        }
      }

      formatMoney(cents) {
        const format = this.moneyFormat || '{{amount}}';
        const fmt = (n, decimals, thousands, decimal) => {
          const fixed = (n / 100).toFixed(decimals);
          const [int, dec] = fixed.split('.');
          const withSep = int.replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
          return dec ? withSep + decimal + dec : withSep;
        };
        const out = format.replace(/\{\{\s*(\w+)\s*\}\}/, (m, key) => {
          switch (key) {
            case 'amount_no_decimals': return fmt(cents, 0, ',', '.');
            case 'amount_with_comma_separator': return fmt(cents, 2, '.', ',');
            case 'amount_no_decimals_with_comma_separator': return fmt(cents, 0, '.', ',');
            case 'amount_with_apostrophe_separator': return fmt(cents, 2, "'", '.');
            case 'amount_with_space_separator': return fmt(cents, 2, ' ', ',');
            default: return fmt(cents, 2, ',', '.');
          }
        });
        return out.replace(/<[^>]*>/g, '');
      }

      /* ---------- Bundle / package selector ---------- */
      /* A card with a linked product switches what Add to cart submits (its variant id).
         A card with no linked product just sets the quantity field. */
      setupSocialVideos() {
        const buttons = Array.from(this.querySelectorAll('[data-video-id]'));
        if (!buttons.length) return;
        buttons.forEach((btn) => {
          btn.addEventListener('click', () => {
            const id = btn.dataset.videoId;
            const template = this.querySelector(`template[data-video-source="${id}"]`);
            if (!template) return;
            const container = btn.closest('.pi__socialvideos');
            const speed = container ? parseFloat(container.dataset.videoSpeed) || 1 : 1;
            const wrapper = document.createElement('div');
            wrapper.className = 'pi__video-player';
            wrapper.appendChild(template.content.cloneNode(true));
            btn.replaceWith(wrapper);
            const media = wrapper.querySelector('video, iframe');
            if (media && media.tagName === 'VIDEO') media.playbackRate = speed;
            if (media && media.play) media.play().catch(() => {});
          });
        });
      }

      setupBundles() {
        const cards = Array.from(this.querySelectorAll('[data-bundle-card]'));
        if (!cards.length) return;
        const qtyInput = this.querySelector('[data-qty-input]');

        cards.forEach((card) => {
          const input = card.querySelector('[data-bundle-input]');
          if (!input) return;
          input.addEventListener('change', () => {
            const variantId = card.dataset.bundleVariantId;
            const imageUrl = card.dataset.bundleImage;
            const productUrl = card.dataset.bundleProductUrl;

            // Linked-product card: go straight to that product's own page.
            if (productUrl) {
              window.location.href = productUrl;
              return;
            }

            // Swap the main gallery image to match the selected package, when one is set.
            if (imageUrl && this.slides.length) {
              const slide = this.slides[this.index] || this.slides[0];
              const img = slide && slide.querySelector('img');
              if (img) {
                img.removeAttribute('srcset');
                img.removeAttribute('sizes');
                img.src = imageUrl;
              }
            }

            if (variantId) {
              // Linked-product card: swap the hidden variant id and reflect its price/availability.
              if (this.idInput) this.idInput.value = variantId;
              const available = card.dataset.bundleVariantAvailable !== 'false';
              this.setButton(available, available ? this.addText : this.dataset.soldOut);

              if (this.priceEl) {
                const priceText = card.querySelector('.pi__bundle-price strong');
                const compareText = card.querySelector('.pi__bundle-price s');
                const onSale = !!compareText;
                this.priceEl.classList.toggle('price--on-sale', onSale);
                const regEl = this.priceEl.querySelector('[data-price-regular]');
                const saleEl = this.priceEl.querySelector('[data-price-sale]');
                const compEl = this.priceEl.querySelector('[data-price-compare]');
                if (priceText) {
                  if (regEl) regEl.textContent = priceText.textContent;
                  if (saleEl) saleEl.textContent = priceText.textContent;
                }
                if (compEl) compEl.textContent = onSale ? compareText.textContent : '';
              }
              // A linked product sells on its own, so quantity stays at whatever the shopper set.
            } else if (qtyInput) {
              const qty = Math.max(1, parseInt(input.value, 10) || 1);
              qtyInput.value = qty;
              qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
            }
          });
        });
      }

      /* ---------- Quantity ---------- */
      setupQuantity() {
        const input = this.querySelector('[data-qty-input]');
        if (!input) return;
        this.querySelectorAll('[data-qty]').forEach((btn) => {
          btn.addEventListener('click', () => {
            const next = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(btn.dataset.qty, 10));
            input.value = next;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          });
        });
      }
    }

    customElements.define('adumi-product', AdumiProduct);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["number-band"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('number-band')) {
    class NumberBand extends HTMLElement {
      connectedCallback() {
        this.values = Array.from(this.querySelectorAll('[data-count]'));
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const editor = window.Shopify && window.Shopify.designMode;
        if (!this.values.length || reduce || editor || !('IntersectionObserver' in window)) return;

        // Split "60L" into prefix / number / suffix and start from zero
        this.parts = this.values.map((el) => {
          const text = el.dataset.count;
          const m = text.match(/^(\D*)(\d+)(.*)$/);
          if (!m) return null;
          const target = parseInt(m[2], 10);
          el.textContent = m[1] + '0' + m[3];
          return { el, pre: m[1], target, post: m[3] };
        });

        this.observer = new IntersectionObserver(
          ([entry]) => {
            if (entry.isIntersecting) {
              this.observer.disconnect();
              this.run();
            }
          },
          { threshold: 0.4 }
        );
        this.observer.observe(this);
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        cancelAnimationFrame(this.raf);
      }

      run() {
        const duration = 1400;
        const start = performance.now();
        const ease = (t) => 1 - Math.pow(1 - t, 3);
        const tick = (now) => {
          const t = Math.min((now - start) / duration, 1);
          this.parts.forEach((p) => {
            if (!p) return;
            p.el.textContent = p.pre + Math.round(p.target * ease(t)) + p.post;
          });
          if (t < 1) this.raf = requestAnimationFrame(tick);
        };
        this.raf = requestAnimationFrame(tick);
      }
    }

    customElements.define('number-band', NumberBand);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["our-story"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('story-page')) {
    class StoryPage extends HTMLElement {
      connectedCallback() {
        const items = this.querySelectorAll('.st__reveal');
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const inEditor = window.Shopify && window.Shopify.designMode;

        // Without IntersectionObserver, in the theme editor, or with reduced motion: show everything
        if (!('IntersectionObserver' in window) || reduce || inEditor) {
          items.forEach((el) => el.classList.add('is-in'));
          return;
        }

        this.classList.add('is-js');
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                entry.target.classList.add('is-in');
                this.observer.unobserve(entry.target);
              }
            });
          },
          { threshold: 0.12, rootMargin: '0px 0px -6% 0px' }
        );
        items.forEach((el) => this.observer.observe(el));
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }
    }

    customElements.define('story-page', StoryPage);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-cards"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-cards')) {
    class ProductCards extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.prevBtn = this.querySelector('[data-arrow-prev]');
        this.nextBtn = this.querySelector('[data-arrow-next]');
        this.cards = this.track ? Array.from(this.track.children) : [];

        this.querySelectorAll('form[data-pc-form]').forEach((form) => {
          form.addEventListener('submit', (e) => this.onSubmit(e, form));
        });

        if (this.track && this.prevBtn && this.nextBtn) {
          this.prevBtn.addEventListener('click', () => { this.scrollSlide('prev'); this.pauseAutoplay(); });
          this.nextBtn.addEventListener('click', () => { this.scrollSlide('next'); this.pauseAutoplay(); });

          this.onScroll = () => {
            cancelAnimationFrame(this.raf);
            this.raf = requestAnimationFrame(() => this.updateArrows());
          };
          this.track.addEventListener('scroll', this.onScroll, { passive: true });
          this.updateArrows();
        }

        const delay = this.track ? parseInt(this.track.dataset.autoplay, 10) : 0;
        if (this.track && delay) {
          this.autoplayDelay = delay;
          this.mq = window.matchMedia('(max-width: 749px)');
          this.track.addEventListener('pointerdown', () => this.pauseAutoplay());
          this.track.addEventListener('touchstart', () => this.pauseAutoplay(), { passive: true });
          document.addEventListener('visibilitychange', () => {
            if (document.hidden) this.pauseAutoplay();
            else this.startAutoplay();
          });
          this.startAutoplay();
        }
      }

      disconnectedCallback() {
        if (this.track) this.track.removeEventListener('scroll', this.onScroll);
        this.pauseAutoplay();
      }

      startAutoplay() {
        if (!this.autoplayDelay || !this.mq || !this.mq.matches) return;
        this.pauseAutoplay();
        this.autoplayTimer = setInterval(() => {
          const maxScroll = this.track.scrollWidth - this.track.clientWidth - 4;
          if (this.track.scrollLeft >= maxScroll) {
            this.track.scrollTo({ left: 0, behavior: 'smooth' });
          } else {
            this.scrollSlide('next');
          }
        }, this.autoplayDelay);
      }

      pauseAutoplay() {
        clearInterval(this.autoplayTimer);
      }

      scrollSlide(direction) {
        const cardWidth = this.cards[0] ? this.cards[0].offsetWidth : this.track.clientWidth;
        const scrollAmount = cardWidth + 16;

        if (direction === 'prev') {
          this.track.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
        } else {
          this.track.scrollBy({ left: scrollAmount, behavior: 'smooth' });
        }
      }

      updateArrows() {
        if (!this.prevBtn || !this.nextBtn) return;
        const x = this.track.scrollLeft;
        const maxScroll = this.track.scrollWidth - this.track.clientWidth - 4;

        this.prevBtn.disabled = x <= 4;
        this.nextBtn.disabled = x >= maxScroll;
      }

      async onSubmit(e, form) {
        const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        const canAjax =
          window.fetch &&
          cart &&
          typeof cart.renderContents === 'function' &&
          typeof cart.getSectionsToRender === 'function';
        if (!canAjax) return;

        e.preventDefault();
        const btn = form.querySelector('button[type="submit"]');
        if (btn.getAttribute('aria-busy') === 'true') return;
        btn.setAttribute('aria-busy', 'true');
        btn.disabled = true;

        const body = new FormData(form);
        body.append('sections', cart.getSectionsToRender().map((s) => s.id).join(','));
        body.append('sections_url', window.location.pathname);
        if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);

        try {
          const url = form.getAttribute('action').replace(/\.js$/, '') + '.js';
          const res = await fetch(url, {
            method: 'POST',
            headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
            body,
          });
          const json = await res.json();
          if (json.status) throw new Error(json.description || 'Could not add to cart');
          cart.renderContents(json);
        } catch (err) {
          btn.removeAttribute('aria-busy');
          btn.disabled = false;
          form.submit();
          return;
        }

        btn.removeAttribute('aria-busy');
        btn.disabled = false;
      }
    }

    customElements.define('product-cards', ProductCards);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information-refill"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('adumi-refill')) {
    class AdumiRefill extends HTMLElement {
      connectedCallback() {
        this.slidesEl = this.querySelector('[data-slides]');
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.thumbs = Array.from(this.querySelectorAll('[data-thumb]'));
        this.thumbsList = this.querySelector('[data-thumbs]');
        this.counter = this.querySelector('[data-counter]');
        this.prev = this.querySelector('[data-prev]');
        this.next = this.querySelector('[data-next]');
        this.index = 0;

        this.setupGallery();
        this.setupTabs();
        this.setupVariants();
      }

      disconnectedCallback() {
        if (this.slideObserver) this.slideObserver.disconnect();
      }

      /* ---------- Gallery ---------- */
      setupGallery() {
        if (!this.slidesEl || this.slides.length < 2) return;

        this.thumbs.forEach((t) => t.addEventListener('click', () => this.goTo(parseInt(t.dataset.thumb, 10))));
        if (this.prev) this.prev.addEventListener('click', () => this.goTo(this.index - 1));
        if (this.next) this.next.addEventListener('click', () => this.goTo(this.index + 1));

        this.slidesEl.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowLeft') this.goTo(this.index - 1);
          if (e.key === 'ArrowRight') this.goTo(this.index + 1);
        });

        this.slideObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting && entry.intersectionRatio > 0.6) {
                this.setActive(parseInt(entry.target.dataset.slide, 10));
              }
            });
          },
          { root: this.slidesEl, threshold: [0.6] }
        );
        this.slides.forEach((s) => this.slideObserver.observe(s));

        const start = this.slides.findIndex((s) => s.dataset.mediaId === this.dataset.startMedia);
        if (start > 0) this.goTo(start, false);
        else this.setActive(0);
      }

      goTo(i, smooth = true) {
        if (!this.slides.length) return;
        const target = Math.max(0, Math.min(this.slides.length - 1, i));
        this.slidesEl.scrollTo({ left: this.slides[target].offsetLeft, behavior: smooth ? 'smooth' : 'auto' });
        this.setActive(target);
      }

      goToMedia(mediaId) {
        const i = this.slides.findIndex((s) => s.dataset.mediaId === String(mediaId));
        if (i >= 0) this.goTo(i);
      }

      setActive(i) {
        if (i === this.index && this.activeSet) return;
        this.index = i;
        this.activeSet = true;

        this.thumbs.forEach((t, n) => t.setAttribute('aria-current', n === i ? 'true' : 'false'));
        if (this.counter) this.counter.textContent = i + 1;
        if (this.prev) this.prev.disabled = i === 0;
        if (this.next) this.next.disabled = i === this.slides.length - 1;

        const thumb = this.thumbs[i];
        if (thumb && this.thumbsList) {
          const list = this.thumbsList;
          const vertical = list.scrollHeight > list.clientHeight + 2;
          if (vertical) {
            const top = thumb.offsetTop - list.clientHeight / 2 + thumb.offsetHeight / 2;
            list.scrollTo({ top, behavior: 'smooth' });
          } else {
            const left = thumb.offsetLeft - list.clientWidth / 2 + thumb.offsetWidth / 2;
            list.scrollTo({ left, behavior: 'smooth' });
          }
        }

        this.slides.forEach((s, n) => {
          if (n === i) return;
          const v = s.querySelector('video');
          if (v && !v.paused) v.pause();
        });
      }

      /* ---------- Tabs ---------- */
      setupTabs() {
        this.tabs = Array.from(this.querySelectorAll('[data-tab]'));
        if (!this.tabs.length) return;
        this.tabs.forEach((tab) => tab.addEventListener('click', () => this.activateTab(tab.dataset.tab)));
      }

      activateTab(category) {
        this.tabs.forEach((t) => {
          const active = t.dataset.tab === category;
          t.classList.toggle('is-active', active);
          t.setAttribute('aria-selected', active ? 'true' : 'false');
        });

        this.thumbs.forEach((t) => {
          const li = t.closest('li');
          if (li) li.style.display = t.dataset.category === category ? '' : 'none';
        });

        const firstMatch = this.slides.find((s) => s.dataset.category === category);
        if (firstMatch) this.goTo(this.slides.indexOf(firstMatch));
      }

      /* ---------- Variants (model cards + quantity cards) ---------- */
      setupVariants() {
        this.picker = this.querySelector('[data-variant-picker]');
        this.idInput = this.querySelector('[data-variant-id]');
        this.addButton = this.querySelector('[data-add-button]');
        this.addLabel = this.querySelector('[data-add-label]');
        this.priceEl = this.querySelector('[data-price]');
        this.addText = this.addButton ? this.addButton.dataset.addText : '';

        try {
          this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
          this.moneyFormat = JSON.parse(this.querySelector('[data-money-format]').textContent);
          this.cardData = JSON.parse(this.querySelector('[data-card-data]').textContent);
        } catch (e) {
          this.variants = [];
          this.cardData = {};
        }

        if (!this.picker) return;
        this.picker.addEventListener('change', () => this.onOptionChange());
        this.updateAvailability();
      }

      selectedOptions() {
        return Array.from(this.picker.querySelectorAll('fieldset')).map((fs) => {
          const checked = fs.querySelector('input:checked');
          return checked ? checked.value : null;
        });
      }

      onOptionChange() {
        const options = this.selectedOptions();
        const variant = this.variants.find((v) => v.options.every((o, i) => o === options[i]));

        this.updateCards(options);
        this.updateAvailability();

        if (!variant) {
          this.setButton(false, this.dataset.unavailable);
          return;
        }

        if (this.idInput) this.idInput.value = variant.id;
        this.updatePrice(variant);
        this.setButton(variant.available, variant.available ? this.addText : this.dataset.soldOut);
        if (variant.featured_media) this.goToMedia(variant.featured_media.id);

        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }

      // Keeps each card's label, note, subtitle, image and price in step with the chosen model
      updateCards(options) {
        this.picker.querySelectorAll('[data-card]').forEach((card) => {
          const idx = parseInt(card.dataset.optionIndex, 10);
          const val = card.dataset.value;
          const test = options.slice();
          test[idx] = val;

          let v = this.variants.find((x) => x.options.every((o, i) => o === test[i]));
          if (!v) v = this.variants.find((x) => x.options[idx] === val);
          if (!v) return;

          const data = this.cardData[String(v.id)] || {};

          const subtitle = card.querySelector('[data-card-subtitle]');
          if (subtitle) subtitle.textContent = data.subtitle || '';

          const note = card.querySelector('[data-card-note]');
          if (note) note.textContent = data.note || '';

          const label = card.querySelector('[data-card-label]');
          if (label) {
            label.textContent = data.label || '';
            label.hidden = !data.label;
          }

          const price = card.querySelector('[data-card-price]');
          if (price) price.textContent = this.formatMoney(v.price);

          const compare = card.querySelector('[data-card-compare]');
          if (compare) {
            compare.textContent = v.compare_at_price && v.compare_at_price > v.price ? this.formatMoney(v.compare_at_price) : '';
          }

          const img = card.querySelector('.pi__model-img img');
          if (img && v.featured_image && v.featured_image.src) {
            img.removeAttribute('srcset');
            img.removeAttribute('sizes');
            img.src = v.featured_image.src;
          }
        });
      }

      // Fades values that cannot be bought with the other current choices
      updateAvailability() {
        const options = this.selectedOptions();
        this.picker.querySelectorAll('input[data-option-index]').forEach((input) => {
          const idx = parseInt(input.dataset.optionIndex, 10);
          const test = options.slice();
          test[idx] = input.value;
          const match = this.variants.find((v) => v.options.every((o, i) => o === test[i]));
          input.closest('[data-value-wrap]').classList.toggle('is-unavailable', !match || !match.available);
        });
      }

      setButton(available, text) {
        if (!this.addButton) return;
        this.addButton.disabled = !available;
        if (this.addLabel && text) this.addLabel.textContent = text;
      }

      updatePrice(variant) {
        if (!this.priceEl) return;
        const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
        this.priceEl.classList.toggle('price--on-sale', !!onSale);
        const price = this.formatMoney(variant.price);
        this.priceEl.querySelector('[data-price-regular]').textContent = price;
        this.priceEl.querySelector('[data-price-sale]').textContent = price;
        this.priceEl.querySelector('[data-price-compare]').textContent = onSale ? this.formatMoney(variant.compare_at_price) : '';

        const badgeEl = this.querySelector('[data-price-badge]');
        if (badgeEl) {
          if (onSale) {
            const suffix = badgeEl.dataset.badgeText || '';
            const percent = Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);
            badgeEl.textContent = `${percent}% ${suffix}`;
          } else {
            badgeEl.textContent = '';
          }
        }
      }

      formatMoney(cents) {
        const format = this.moneyFormat || '{{amount}}';
        const fmt = (n, decimals, thousands, decimal) => {
          const fixed = (n / 100).toFixed(decimals);
          const [int, dec] = fixed.split('.');
          const withSep = int.replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
          return dec ? withSep + decimal + dec : withSep;
        };
        const out = format.replace(/\{\{\s*(\w+)\s*\}\}/, (m, key) => {
          switch (key) {
            case 'amount_no_decimals': return fmt(cents, 0, ',', '.');
            case 'amount_with_comma_separator': return fmt(cents, 2, '.', ',');
            case 'amount_no_decimals_with_comma_separator': return fmt(cents, 0, '.', ',');
            case 'amount_with_apostrophe_separator': return fmt(cents, 2, "'", '.');
            case 'amount_with_space_separator': return fmt(cents, 2, ' ', ',');
            default: return fmt(cents, 2, ',', '.');
          }
        });
        return out.replace(/<[^>]*>/g, '');
      }
    }

    customElements.define('adumi-refill', AdumiRefill);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-page-custom-liquid"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('adumi-product')) {
    class AdumiProduct extends HTMLElement {
      connectedCallback() {
        this.slidesEl = this.querySelector('[data-slides]');
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.thumbs = Array.from(this.querySelectorAll('[data-thumb]'));
        this.thumbsList = this.querySelector('[data-thumbs]');
        this.counter = this.querySelector('[data-counter]');
        this.prev = this.querySelector('[data-prev]');
        this.next = this.querySelector('[data-next]');
        this.index = 0;

        this.setupGallery();
        this.setupTabs();
        this.setupVariants();
        this.setupQuantity();
      }

      disconnectedCallback() {
        if (this.slideObserver) this.slideObserver.disconnect();
      }

      /* ---------- Gallery ---------- */
      setupGallery() {
        if (!this.slidesEl || this.slides.length < 2) return;

        this.thumbs.forEach((t) => t.addEventListener('click', () => this.goTo(parseInt(t.dataset.thumb, 10))));
        if (this.prev) this.prev.addEventListener('click', () => this.goTo(this.index - 1));
        if (this.next) this.next.addEventListener('click', () => this.goTo(this.index + 1));

        this.slidesEl.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowLeft') this.goTo(this.index - 1);
          if (e.key === 'ArrowRight') this.goTo(this.index + 1);
        });

        // Track which slide is in view (also after swiping on mobile)
        this.slideObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting && entry.intersectionRatio > 0.6) {
                this.setActive(parseInt(entry.target.dataset.slide, 10));
              }
            });
          },
          { root: this.slidesEl, threshold: [0.6] }
        );
        this.slides.forEach((s) => this.slideObserver.observe(s));

        // Start on the selected variant's image
        const start = this.slides.findIndex((s) => s.dataset.mediaId === this.dataset.startMedia);
        if (start > 0) this.goTo(start, false);
        else this.setActive(0);
      }

      goTo(i, smooth = true) {
        if (!this.slides.length) return;
        const target = Math.max(0, Math.min(this.slides.length - 1, i));
        this.slidesEl.scrollTo({ left: this.slides[target].offsetLeft, behavior: smooth ? 'smooth' : 'auto' });
        this.setActive(target);
      }

      goToMedia(mediaId) {
        const i = this.slides.findIndex((s) => s.dataset.mediaId === String(mediaId));
        if (i >= 0) this.goTo(i);
      }

      setActive(i) {
        if (i === this.index && this.activeSet) return;
        this.index = i;
        this.activeSet = true;

        this.thumbs.forEach((t, n) => t.setAttribute('aria-current', n === i ? 'true' : 'false'));
        if (this.counter) this.counter.textContent = i + 1;
        if (this.prev) this.prev.disabled = i === 0;
        if (this.next) this.next.disabled = i === this.slides.length - 1;

        // Keep the active thumbnail in view inside its own list (no page jump)
        const thumb = this.thumbs[i];
        if (thumb && this.thumbsList) {
          const list = this.thumbsList;
          const vertical = list.scrollHeight > list.clientHeight + 2;
          if (vertical) {
            const top = thumb.offsetTop - list.clientHeight / 2 + thumb.offsetHeight / 2;
            list.scrollTo({ top, behavior: 'smooth' });
          } else {
            const left = thumb.offsetLeft - list.clientWidth / 2 + thumb.offsetWidth / 2;
            list.scrollTo({ left, behavior: 'smooth' });
          }
        }

        // Pause videos that are not on screen
        this.slides.forEach((s, n) => {
          if (n === i) return;
          const v = s.querySelector('video');
          if (v && !v.paused) v.pause();
        });
      }

      /* ---------- Tabs (Product / Before & After / Video) ---------- */
      setupTabs() {
        this.tabs = Array.from(this.querySelectorAll('[data-tab]'));
        if (!this.tabs.length) return;
        this.tabs.forEach((tab) => {
          tab.addEventListener('click', () => this.activateTab(tab.dataset.tab));
        });
      }

      activateTab(category) {
        this.tabs.forEach((t) => {
          const active = t.dataset.tab === category;
          t.classList.toggle('is-active', active);
          t.setAttribute('aria-selected', active ? 'true' : 'false');
        });

        this.thumbs.forEach((t) => {
          const match = t.dataset.category === category;
          const li = t.closest('li');
          if (li) li.style.display = match ? '' : 'none';
        });

        const firstMatch = this.slides.find((s) => s.dataset.category === category);
        if (firstMatch) this.goTo(this.slides.indexOf(firstMatch));
      }

      /* ---------- Variants ---------- */
      setupVariants() {
        this.picker = this.querySelector('[data-variant-picker]');
        this.idInput = this.querySelector('[data-variant-id]');
        this.addButton = this.querySelector('[data-add-button]');
        this.addLabel = this.querySelector('[data-add-label]');
        this.priceEl = this.querySelector('[data-price]');
        this.addText = this.addButton ? this.addButton.dataset.addText : '';

        try {
          this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
          this.moneyFormat = JSON.parse(this.querySelector('[data-money-format]').textContent);
        } catch (e) {
          this.variants = [];
        }

        if (!this.picker) return;
        this.picker.addEventListener('change', () => this.onOptionChange());
        this.updateAvailability();
      }

      selectedOptions() {
        const fieldsets = Array.from(this.picker.querySelectorAll('fieldset'));
        return fieldsets.map((fs) => {
          const checked = fs.querySelector('input:checked');
          return checked ? checked.value : null;
        });
      }

      onOptionChange() {
        const options = this.selectedOptions();
        options.forEach((val, i) => {
          const label = this.querySelector(`[data-option-label="${i}"]`);
          if (label) label.textContent = val;
        });

        const variant = this.variants.find((v) => v.options.every((o, i) => o === options[i]));
        this.updateAvailability();

        if (!variant) {
          this.setButton(false, this.dataset.unavailable);
          return;
        }

        if (this.idInput) this.idInput.value = variant.id;
        this.updatePrice(variant);
        this.setButton(variant.available, variant.available ? this.addText : this.dataset.soldOut);
        if (variant.featured_media) this.goToMedia(variant.featured_media.id);

        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }

      // Strike through values that can't be bought with the other current choices
      updateAvailability() {
        const options = this.selectedOptions();
        this.picker.querySelectorAll('input[data-option-index]').forEach((input) => {
          const idx = parseInt(input.dataset.optionIndex, 10);
          const test = options.slice();
          test[idx] = input.value;
          const match = this.variants.find((v) => v.options.every((o, i) => o === test[i]));
          input.closest('[data-value-wrap]').classList.toggle('is-unavailable', !match || !match.available);
        });
      }

      setButton(available, text) {
        if (!this.addButton) return;
        this.addButton.disabled = !available;
        if (this.addLabel && text) this.addLabel.textContent = text;
      }

      updatePrice(variant) {
        if (!this.priceEl) return;
        const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
        this.priceEl.classList.toggle('price--on-sale', !!onSale);
        const price = this.formatMoney(variant.price);
        this.priceEl.querySelector('[data-price-regular]').textContent = price;
        this.priceEl.querySelector('[data-price-sale]').textContent = price;
        this.priceEl.querySelector('[data-price-compare]').textContent = onSale ? this.formatMoney(variant.compare_at_price) : '';
      }

      formatMoney(cents) {
        const format = this.moneyFormat || '{{amount}}';
        const fmt = (n, decimals, thousands, decimal) => {
          const fixed = (n / 100).toFixed(decimals);
          const [int, dec] = fixed.split('.');
          const withSep = int.replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
          return dec ? withSep + decimal + dec : withSep;
        };
        const out = format.replace(/\{\{\s*(\w+)\s*\}\}/, (m, key) => {
          switch (key) {
            case 'amount_no_decimals': return fmt(cents, 0, ',', '.');
            case 'amount_with_comma_separator': return fmt(cents, 2, '.', ',');
            case 'amount_no_decimals_with_comma_separator': return fmt(cents, 0, '.', ',');
            case 'amount_with_apostrophe_separator': return fmt(cents, 2, "'", '.');
            case 'amount_with_space_separator': return fmt(cents, 2, ' ', ',');
            default: return fmt(cents, 2, ',', '.');
          }
        });
        return out.replace(/<[^>]*>/g, '');
      }

      /* ---------- Quantity ---------- */
      setupQuantity() {
        const input = this.querySelector('[data-qty-input]');
        if (!input) return;
        this.querySelectorAll('[data-qty]').forEach((btn) => {
          btn.addEventListener('click', () => {
            const next = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(btn.dataset.qty, 10));
            input.value = next;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          });
        });
      }
    }

    customElements.define('adumi-product', AdumiProduct);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promise-band"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('promise-band')) {
    class PromiseBand extends HTMLElement {
      connectedCallback() {
        const items = this.querySelectorAll('[data-reveal]');
        if ((window.Shopify && window.Shopify.designMode) || !('IntersectionObserver' in window)) {
          items.forEach((el) => el.classList.add('is-visible'));
          return;
        }
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                entry.target.classList.add('is-visible');
                this.observer.unobserve(entry.target);
              }
            });
          },
          { threshold: 0.15 }
        );
        items.forEach((el) => this.observer.observe(el));
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }
    }

    customElements.define('promise-band', PromiseBand);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["review-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('review-slider')) {
    class ReviewSlider extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-dot]'));
        this.index = 0;
        this.paused = false;
        this.visible = true;
        this.interval = parseInt(this.dataset.interval, 10) || 6000;

        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.autoplay = this.dataset.autoplay === 'true' && !reduce && this.slides.length > 1;

        this.dots.forEach((d) =>
          d.addEventListener('click', () => {
            this.show(parseInt(d.dataset.dot, 10));
            this.restart();
          })
        );

        // Pause while the visitor hovers or focuses inside the slider
        this.addEventListener('mouseenter', () => this.pause());
        this.addEventListener('mouseleave', () => this.resume());
        this.addEventListener('focusin', () => this.pause());
        this.addEventListener('focusout', () => this.resume());

        // Swipe on touch screens
        let startX = null;
        this.addEventListener(
          'touchstart',
          (e) => {
            startX = e.touches[0].clientX;
          },
          { passive: true }
        );
        this.addEventListener(
          'touchend',
          (e) => {
            if (startX === null) return;
            const dx = e.changedTouches[0].clientX - startX;
            startX = null;
            if (Math.abs(dx) > 40) {
              this.show(this.index + (dx < 0 ? 1 : -1));
              this.restart();
            }
          },
          { passive: true }
        );

        // Only rotate while the section is on screen and the tab is open
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(([entry]) => {
            this.visible = entry.isIntersecting;
            this.visible ? this.start() : this.stop();
          });
          this.observer.observe(this);
        } else {
          this.start();
        }

        this.onVisibility = () => (document.hidden ? this.stop() : this.start());
        document.addEventListener('visibilitychange', this.onVisibility);

        // Theme editor: selecting a slide shows it
        this.onBlockSelect = (e) => {
          const i = this.slides.findIndex((s) => s.dataset.blockId === e.detail.blockId);
          if (i >= 0) {
            this.show(i);
            this.stop();
          }
        };
        document.addEventListener('shopify:block:select', this.onBlockSelect);
      }

      disconnectedCallback() {
        this.stop();
        if (this.observer) this.observer.disconnect();
        document.removeEventListener('visibilitychange', this.onVisibility);
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
      }

      show(i) {
        const n = this.slides.length;
        this.index = (i + n) % n;
        this.slides.forEach((s, k) => {
          const active = k === this.index;
          s.classList.toggle('is-active', active);
          if (active) s.removeAttribute('aria-hidden');
          else s.setAttribute('aria-hidden', 'true');
        });
        this.dots.forEach((d, k) => d.setAttribute('aria-current', k === this.index ? 'true' : 'false'));
      }

      start() {
        if (!this.autoplay || this.paused || !this.visible || this.timer) return;
        this.timer = setInterval(() => this.show(this.index + 1), this.interval);
      }

      stop() {
        clearInterval(this.timer);
        this.timer = null;
      }

      restart() {
        this.stop();
        this.start();
      }

      pause() {
        this.paused = true;
        this.stop();
      }

      resume() {
        this.paused = false;
        this.start();
      }
    }

    customElements.define('review-slider', ReviewSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scroll-blur-cards"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('scroll-blur-cards')) {
    class ScrollBlurCards extends HTMLElement {
      connectedCallback() {
        this.fade = parseFloat(this.dataset.fade) || 0.4;
        this.ticking = false;

        this.onScroll = () => {
          if (this.ticking) return;
          this.ticking = true;
          requestAnimationFrame(() => {
            this.update();
            this.ticking = false;
          });
        };

        // Listen to scroll only while the section is on screen
        this.visibilityObserver = new IntersectionObserver(([entry]) => {
          if (entry.isIntersecting) {
            window.addEventListener('scroll', this.onScroll, { passive: true });
            window.addEventListener('resize', this.onScroll, { passive: true });
            this.update();
          } else {
            window.removeEventListener('scroll', this.onScroll);
            window.removeEventListener('resize', this.onScroll);
          }
        });
        this.visibilityObserver.observe(this);

        // Cards fade up once when they enter the viewport
        const items = this.querySelectorAll('[data-reveal]');
        if ('IntersectionObserver' in window) {
          this.revealObserver = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (entry.isIntersecting) {
                  entry.target.classList.add('is-visible');
                  this.revealObserver.unobserve(entry.target);
                }
              });
            },
            { threshold: 0.15 }
          );
          items.forEach((el) => this.revealObserver.observe(el));
        } else {
          items.forEach((el) => el.classList.add('is-visible'));
        }

        // Theme editor: always show cards so they can be edited
        if (window.Shopify && window.Shopify.designMode) {
          items.forEach((el) => el.classList.add('is-visible'));
        }

        this.update();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
        if (this.visibilityObserver) this.visibilityObserver.disconnect();
        if (this.revealObserver) this.revealObserver.disconnect();
      }

      // 0 = image fully clear, 1 = fully blurred
      update() {
        const rect = this.getBoundingClientRect();
        const distance = window.innerHeight * this.fade;
        const progress = Math.min(Math.max(-rect.top / distance, 0), 1);
        this.style.setProperty('--p', progress.toFixed(3));
      }
    }

    customElements.define('scroll-blur-cards', ScrollBlurCards);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scroll-blur-feature"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('scroll-blur-section')) {
    class ScrollBlurSection extends HTMLElement {
      connectedCallback() {
        this.fade = parseFloat(this.dataset.fade) || 0.4;
        this.ticking = false;

        this.onScroll = () => {
          if (this.ticking) return;
          this.ticking = true;
          requestAnimationFrame(() => {
            this.update();
            this.ticking = false;
          });
        };

        // Only listen to scroll while the section is on screen
        this.visibilityObserver = new IntersectionObserver(([entry]) => {
          if (entry.isIntersecting) {
            window.addEventListener('scroll', this.onScroll, { passive: true });
            window.addEventListener('resize', this.onScroll, { passive: true });
            this.update();
          } else {
            window.removeEventListener('scroll', this.onScroll);
            window.removeEventListener('resize', this.onScroll);
          }
        });
        this.visibilityObserver.observe(this);

        // Feature columns fade up when they come into view
        const items = this.querySelectorAll('[data-reveal]');
        if ('IntersectionObserver' in window) {
          this.revealObserver = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (entry.isIntersecting) {
                  entry.target.classList.add('is-visible');
                  this.revealObserver.unobserve(entry.target);
                }
              });
            },
            { threshold: 0.2 }
          );
          items.forEach((el) => this.revealObserver.observe(el));
        } else {
          items.forEach((el) => el.classList.add('is-visible'));
        }

        // Theme editor: always show features so they can be edited
        if (window.Shopify && window.Shopify.designMode) {
          items.forEach((el) => el.classList.add('is-visible'));
        }

        this.update();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
        if (this.visibilityObserver) this.visibilityObserver.disconnect();
        if (this.revealObserver) this.revealObserver.disconnect();
      }

      // 0 = image fully clear (section top at top of screen), 1 = fully blurred
      update() {
        const rect = this.getBoundingClientRect();
        const distance = window.innerHeight * this.fade;
        const progress = Math.min(Math.max(-rect.top / distance, 0), 1);
        this.style.setProperty('--p', progress.toFixed(3));
      }
    }

    customElements.define('scroll-blur-section', ScrollBlurSection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scroll-rotating-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('scroll-video-section')) {
    class ScrollVideoSection extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.canvas = this.querySelector('.sv__canvas');
        this.ctx = this.canvas.getContext('2d');
        this.video = this.querySelector('.sv__source');
        this.steps = Array.from(this.querySelectorAll('[data-step]')).map((el) => ({
          el,
          start: parseFloat(el.dataset.start) || 0,
          end: parseFloat(el.dataset.end) || 100,
        }));

        this.current = 0;
        this.target = 0;
        this.duration = 0;
        this.ready = false;
        this.running = false;
        this.mobile = window.matchMedia('(max-width: 749px)');

        this.onScroll = () => {
          cancelAnimationFrame(this.measureRaf);
          this.measureRaf = requestAnimationFrame(() => this.measure());
        };
        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onScroll, { passive: true });

        // Start loading the video shortly before the section reaches the screen
        this.observer = new IntersectionObserver(
          ([entry]) => {
            if (entry.isIntersecting) {
              this.load();
              this.start();
            } else {
              this.stop();
            }
          },
          { rootMargin: '75% 0px' }
        );
        this.observer.observe(this);

        // Theme editor: selecting a text block shows it
        this.onBlockSelect = (e) => {
          const step = this.querySelector(`[data-block-id="${e.detail.blockId}"]`);
          this.steps.forEach((s) => s.el.classList.toggle('is-forced', s.el === step));
        };
        this.onBlockDeselect = () => this.steps.forEach((s) => s.el.classList.remove('is-forced'));
        document.addEventListener('shopify:block:select', this.onBlockSelect);
        document.addEventListener('shopify:block:deselect', this.onBlockDeselect);

        this.measure();
      }

      disconnectedCallback() {
        this.stop();
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
        document.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
        if (this.observer) this.observer.disconnect();
        if (this.blobUrl) URL.revokeObjectURL(this.blobUrl);
      }

      load() {
        if (this.loaded) return;
        this.loaded = true;

        const v = this.video;
        const src = (this.mobile.matches && v.dataset.srcMobile) || v.dataset.src;
        if (!src) return;

        v.addEventListener(
          'loadedmetadata',
          () => {
            this.canvas.width = v.videoWidth;
            this.canvas.height = v.videoHeight;
            this.duration = v.duration;
            this.measure();
          },
          { once: true }
        );

        v.addEventListener(
          'loadeddata',
          () => {
            this.ready = true;
            v.currentTime = Math.max(this.target, 0.001);
          },
          { once: true }
        );

        // Draw every time a new frame is ready after seeking
        v.addEventListener('seeked', () => this.draw());

        const useUrl = (url) => {
          v.src = url;
          v.load();
        };

        // Download the whole video first so seeking is instant and smooth
        fetch(src)
          .then((r) => {
            if (!r.ok) throw new Error('fetch failed');
            return r.blob();
          })
          .then((blob) => {
            this.blobUrl = URL.createObjectURL(blob);
            useUrl(this.blobUrl);
          })
          .catch(() => useUrl(src));
      }

      draw() {
        if (this.video.readyState < 2) return;
        this.ctx.drawImage(this.video, 0, 0, this.canvas.width, this.canvas.height);
        if (!this.classList.contains('is-ready')) this.classList.add('is-ready');
      }

      measure() {
        const rect = this.track.getBoundingClientRect();
        const total = rect.height - window.innerHeight;
        const progress = total > 0 ? Math.min(Math.max(-rect.top / total, 0), 1) : 0;

        if (this.duration) this.target = progress * Math.max(this.duration - 0.05, 0);

        const pct = progress * 100;
        this.steps.forEach((s) => {
          const state = pct < s.start ? 'before' : pct > s.end ? 'after' : 'active';
          if (s.el.dataset.state !== state) s.el.dataset.state = state;
        });
      }

      // Smoothly move the video time toward the scroll position
      start() {
        if (this.running) return;
        this.running = true;
        const tick = () => {
          if (!this.running) return;
          if (this.ready && this.duration) {
            this.current += (this.target - this.current) * 0.2;
            if (Math.abs(this.target - this.current) < 0.002) this.current = this.target;
            if (!this.video.seeking && Math.abs(this.video.currentTime - this.current) > 0.01) {
              this.video.currentTime = this.current;
            }
          }
          this.raf = requestAnimationFrame(tick);
        };
        this.raf = requestAnimationFrame(tick);
      }

      stop() {
        this.running = false;
        cancelAnimationFrame(this.raf);
      }
    }

    customElements.define('scroll-video-section', ScrollVideoSection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scroll-story"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('scroll-story')) {
    class ScrollStory extends HTMLElement {
      connectedCallback() {
        this.chapters = Array.from(this.querySelectorAll('[data-chapter]'));
        this.media = Array.from(this.querySelectorAll('[data-media]'));
        this.rail = Array.from(this.querySelectorAll('[data-rail]'));
        this.inlineVideos = Array.from(this.querySelectorAll('.ss__inline-media video'));
        this.desktop = window.matchMedia('(min-width: 990px)');
        this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.active = -1;
        if (!this.chapters.length) return;

        // A chapter becomes active when it crosses the middle of the screen
        this.chapterObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) this.setActive(parseInt(entry.target.dataset.chapter, 10));
            });
          },
          { rootMargin: '-45% 0px -45% 0px', threshold: 0 }
        );
        this.chapters.forEach((c) => this.chapterObserver.observe(c));

        // Mobile: inline videos play only while visible
        if (this.inlineVideos.length && !this.reduce) {
          this.inlineObserver = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (this.desktop.matches) return;
                const v = entry.target;
                if (entry.isIntersecting) v.play().catch(() => {});
                else v.pause();
              });
            },
            { threshold: 0.5 }
          );
          this.inlineVideos.forEach((v) => this.inlineObserver.observe(v));
        }

        // Stop stage video when the whole section is off screen
        this.sectionObserver = new IntersectionObserver(([entry]) => {
          this.visible = entry.isIntersecting;
          this.syncStageVideo();
        });
        this.sectionObserver.observe(this);

        // Theme editor: selecting a chapter block shows its image
        this.onBlockSelect = (e) => {
          const ch = this.querySelector(`[data-block-id="${e.detail.blockId}"]`);
          if (ch) this.setActive(parseInt(ch.dataset.chapter, 10));
        };
        document.addEventListener('shopify:block:select', this.onBlockSelect);

        this.setActive(0);
      }

      disconnectedCallback() {
        if (this.chapterObserver) this.chapterObserver.disconnect();
        if (this.inlineObserver) this.inlineObserver.disconnect();
        if (this.sectionObserver) this.sectionObserver.disconnect();
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
      }

      setActive(index) {
        if (index === this.active || isNaN(index)) return;
        this.active = index;
        this.chapters.forEach((c, i) => c.classList.toggle('is-active', i === index));
        this.media.forEach((m, i) => m.classList.toggle('is-active', i === index));
        this.rail.forEach((r, i) => r.classList.toggle('is-done', i <= index));
        this.syncStageVideo();
      }

      syncStageVideo() {
        this.media.forEach((m, i) => {
          const v = m.querySelector('video');
          if (!v) return;
          if (this.visible && this.desktop.matches && i === this.active && !this.reduce) {
            v.play().catch(() => {});
          } else {
            v.pause();
          }
        });
      }
    }

    customElements.define('scroll-story', ScrollStory);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-atc"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sticky-atc')) {
    class StickyAtc extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('[data-sa-button]');
        this.priceEl = this.querySelector('[data-sa-price]');
        this.label = this.button ? this.button.textContent.trim() : '';

        // The theme's real add-to-cart button (Dawn and most Dawn-based themes)
        this.mainButton = document.querySelector(
          'product-form button[name="add"], .product-form__submit, form[action*="/cart/add"] [type="submit"]'
        );
        if (!this.mainButton || !this.button) return;

        // Clicking the bar presses the real button, so variants, quantity and the cart drawer all work
        this.button.addEventListener('click', () => {
          if (this.mainButton.disabled) return;
          this.mainButton.click();
        });

        // Show the bar once the real button has scrolled up out of view
        this.observer = new IntersectionObserver(([entry]) => {
          const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          this.setVisible(scrolledPast);
        });
        this.observer.observe(this.mainButton);

        // Keep price and sold-out state in sync when the variant changes
        this.priceSource = document.querySelector('.product__info-container .price, .product .price');
        this.sync = () => this.syncState();
        this.mutation = new MutationObserver(this.sync);
        if (this.priceSource) this.mutation.observe(this.priceSource, { childList: true, subtree: true, characterData: true, attributes: true });
        this.mutation.observe(this.mainButton, { attributes: true, childList: true, subtree: true });
        this.syncState();
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        if (this.mutation) this.mutation.disconnect();
        document.body.style.paddingBottom = '';
      }

      setVisible(show) {
        this.classList.toggle('is-visible', show);
        this.setAttribute('aria-hidden', show ? 'false' : 'true');
        this.button.tabIndex = show ? 0 : -1;
        // Keep the footer from being hidden behind the bar
        document.body.style.paddingBottom = show ? this.offsetHeight + 'px' : '';
      }

      syncState() {
        if (this.priceSource) {
          const onSale = this.priceSource.classList.contains('price--on-sale');
          const item = onSale
            ? this.priceSource.querySelector('.price__sale .price-item--sale')
            : this.priceSource.querySelector('.price__regular .price-item--regular');
          const text = item && item.textContent.trim();
          if (text) this.priceEl.textContent = text;
        }

        const soldOut = this.mainButton.disabled;
        this.button.disabled = soldOut;
        this.button.textContent = soldOut ? this.mainButton.textContent.trim() : this.label;
      }
    }

    customElements.define('sticky-atc', StickyAtc);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-video"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sticky-video')) {
    class StickyVideo extends HTMLElement {
      connectedCallback() {
        this.sid = this.dataset.section;
        this.popup = document.getElementById('StickyVideoPopup-' + this.sid);
        this.video = this.querySelector('video');
        this.closeBtn = this.querySelector('[data-sv-close]');
        this.trigger = this.querySelector('[data-sv-trigger]');

        if (this.trigger) {
          this.trigger.addEventListener('click', () => this.openPopup());
        }

        if (this.closeBtn) {
          this.closeBtn.addEventListener('click', (e) => {
            e.stopPropagation();
            this.hidden = true;
          });
        }

        if (this.popup) {
          const popupClose = this.popup.querySelector('[data-sv-popup-close]');
          const popupVideo = this.popup.querySelector('video');
          if (popupClose) {
            popupClose.addEventListener('click', () => this.closePopup(popupVideo));
          }
          this.popup.addEventListener('click', (e) => {
            if (e.target === this.popup) this.closePopup(popupVideo);
          });
        }
      }

      openPopup() {
        if (!this.popup) return;
        this.popup.classList.add('is-open');
        this.popup.setAttribute('aria-hidden', 'false');
        const popupVideo = this.popup.querySelector('video');
        if (popupVideo) {
          popupVideo.muted = false;
          popupVideo.currentTime = 0;
          popupVideo.play().catch(() => {});
        }
        document.body.style.overflow = 'hidden';
      }

      closePopup(popupVideo) {
        if (!this.popup) return;
        this.popup.classList.remove('is-open');
        this.popup.setAttribute('aria-hidden', 'true');
        if (popupVideo) popupVideo.pause();
        document.body.style.overflow = '';
      }
    }
    customElements.define('sticky-video', StickyVideo);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["story-split"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('story-split')) {
    class StorySplit extends HTMLElement {
      connectedCallback() {
        const items = this.querySelectorAll('[data-reveal]');
        const showAll = () => items.forEach((el) => el.classList.add('is-visible'));

        if ((window.Shopify && window.Shopify.designMode) || !('IntersectionObserver' in window)) {
          showAll();
          return;
        }

        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                entry.target.classList.add('is-visible');
                this.observer.unobserve(entry.target);
              }
            });
          },
          { threshold: 0.15 }
        );
        items.forEach((el) => this.observer.observe(el));
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }
    }

    customElements.define('story-split', StorySplit);
  }

  } catch(e) { console.error(e); }
})();
})();
